import * as React from "react";
import {
  AboutPeople, AboutAdvance, Founder
} from "../../../uchis_uchitsya";
import * as main from "../../styles/main.module.scss";
import * as advance from "./style.module.scss";
import methodistsData from "./methodistsData.json";

export const AdvanceAdvantages = () => {
  return (
    <section className={advance.advantages}>
      <div className={main.containerFluid}>
        <div className={advance.advantages__wrapper}>
          <img
            className={advance.advantages__img}
            src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/photo-1.jpg"
            alt={""}
          />
          <div>
            <p className={advance.advantages__text}>
              Наши курсы занимают первые места на международных конкурсах, наши программы внедряются в государственную систему обучения (уже 98 школ), и лучшие частные школы страны (Хорошкола, Летово, Школа «Президент» и другие) и да, мы в индивидуальном порядке учим детей министров, селебрити и других VIP клиентов.
            </p>
            <a href="/about/" className={`${main.btn} ${advance.advantages__btn}`}>Подробнее тут</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export const AdvancePeople = () => {
  return (
    <AboutPeople
      data={methodistsData}
      title={"Над курсом трудились методисты, преподаватели, разработчики"}
      bottomText={"...и еще 90+ специалистов"}
      sectionClassName={advance.methodists}
      container={main.containerFluid}
      titleClassName={advance.methodists__title}
      bottomTextClassName={advance.methodists__undertext}
    />
  );
}

export const AdvanceFounder = () => {
  return (
    <Founder
      photo={"https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/circle-nya.png"}
      sectionClassName={advance.founder}
      titleClassName={advance.founder__title}
      quoteBg={'#E9B882'}
      quoteIcon={"https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/quotes.png"}
    />
  );
};

export const AdvanceLicenses = () => {
  return (
    <AboutAdvance
      sectionClassName={advance.licenses}
      container={main.containerFluid}
      titleClassName={`${main.titleH2} ${advance.licenses__title}`}
    />
  );
};
